/** Robbot RPA plugin — CmdScript / Environment helpers */

export const ROBBOT_RPA_PLUGIN_NAMES = ["Robbot RPA", "Qbitra RPA"];

export function isRobbotRpaPlugin(plugin) {
  return !!(plugin && ROBBOT_RPA_PLUGIN_NAMES.includes(plugin.Name));
}

/** Script Name → SunucuTalepForm.rb */
export function rbFileFromScriptName(name) {
  const n = String(name || "").trim();
  if (!n) return "Script.rb";
  return n.toLowerCase().endsWith(".rb") ? n : `${n}.rb`;
}

export const ROBBOT_RPA_CMD_TEMPLATE = `@ECHO OFF
SETLOCAL ENABLEEXTENSIONS ENABLEDELAYEDEXPANSION
set Robbot_run_path="%ProgramW6432%\\Robbot\\Robbot RPA\\RobbotRpa.Run.exe"
%Robbot_run_path% "%script_name%"`;

export function buildRobbotRpaCmdScript(scriptName) {
  const rb = rbFileFromScriptName(scriptName);
  return ROBBOT_RPA_CMD_TEMPLATE.replace("%script_name%", rb);
}

export function mergeRobbotRpaEnvironment(environment, scriptName) {
  return {
    ...(environment || {}),
    script_name: rbFileFromScriptName(scriptName),
  };
}
